exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "dv-schadenfaelle-list:focus{outline:none}.dateinputtable{float:left;width:50%;font-size:x-small;padding-left:1px;padding-right:1px;text-align:center}.setverantwortlicher{-webkit-appearance:none;-moz-appearance:none;border:none;padding:5px 0 0;height:30px;white-space:nowrap}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/app/core/component/dv-schadenfaelle-list/dv-schadenfaelle-list.scss
// module id = wMVE
// module chunks = 0